import { useNavigate } from 'react-router-dom';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import MailOutlinedIcon from '@mui/icons-material/MailOutlined';
import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
import { IconButton, Typography } from '@mui/material';
import './Footer.scss';
import Logo from '../Logo/logo';
import paths from '../../lib/consts/paths';
import useUserMeQuery from '@/reactQuery/hooks/useUserMeQuery';

const Footer = () => {
	const navigate = useNavigate();

	const { data: currentUser } = useUserMeQuery();

	return (
		<section className="home-footer home-section">
			<div className="internal-wrapper">
				<div className="columns">
					<div className="column-logo">
						<Logo />
						<div className="socials">
							<IconButton aria-label="delete" size="medium">
								<InstagramIcon fontSize="inherit" />
							</IconButton>
							<IconButton aria-label="delete" size="medium">
								<YouTubeIcon fontSize="inherit" />
							</IconButton>
						</div>
					</div>
					<div className="column-address">
						<Typography
							variant="h5"
							className="contacts__title"
							sx={{ fontWeight: '600', fontSize: '20px' }}
						>
							Contacts
						</Typography>
						<Typography sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
							<MailOutlinedIcon color="secondary" />
							codeway.today@gmail.com
						</Typography>
						<Typography sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
							<FmdGoodOutlinedIcon color="secondary" />
							Talinn, Avenue road, str 34
						</Typography>
					</div>
					<div className="column-policies">
						<Typography
							variant="h5"
							className="contacts__title"
							sx={{ fontWeight: '600', fontSize: '20px' }}
						>
							Policies
						</Typography>
						<Typography
							variant="body1"
							className="contact-link"
							onClick={() => navigate(paths.privacyPolicy)}
						>
							Privacy policy
						</Typography>
						<Typography
							variant="body1"
							className="contact-link"
							onClick={() => navigate(paths.termsAndConditions)}
						>
							Terms and conditions
						</Typography>
						<Typography
							variant="body1"
							className="contact-link"
							onClick={() => navigate(paths.cookiesInfo)}
						>
							Cookie policy
						</Typography>
					</div>
					{!currentUser?.subscriptionPlanId && (
						<div className="column-start-free">
							<Typography sx={{ fontSize: '50px', fontWeight: '600' }} component="div">
								Get started for <span style={{ color: '#FF7062' }}>FREE</span>
							</Typography>
							<Typography sx={{ fontSize: '25px', color: '#79777C' }}>
								Unleash your thirst for new discoveries
							</Typography>
							<div
								className="home-about__video-button button button-standard"
								style={{ marginTop: '20px' }}
							>
								Try Codeway free
							</div>
						</div>
					)}
				</div>
			</div>
		</section>
	);
};

export default Footer;
